import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ContainerWithItems } from '../../../components/container-with-items/container-with-items';
import { EventProvider } from '../../../providers/event/event';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'src/providers/navigation/navigation.service';

@Component({
  selector: 'page-event-list',
  templateUrl: 'event-list.html',
  styleUrls:['./event-list.scss']
})
export class EventListPage {
  previousUrl:string;
  container: ContainerWithItems;
  hasMoreItems = true;
  pagination = {
    limit: 20, 
    page: 1,
    start: 0
  };
  
  constructor(
    public navCtrl: NavController, 
    public router:Router, 
    private eventService: EventProvider,
    public translate:TranslateService,
    public navService:NavigationService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.container = nav?.extras?.state?.['container'];
    console.log('this.container', this.container)
    // this.container = navParams.data.container;
    this.previousUrl = this.navService.getPreviousUrl();
    if(!this.previousUrl){
      this.navService.pushToHistory('/tab1')
      this.previousUrl = this.navService.getPreviousUrl();
    }
    console.log('previousUrl', this.previousUrl)
  }

  // loadNextPage(paginator) {
  //   this.pagination.page += 1;
  //   this.pagination.start += this.pagination.limit;

  //   this.getEventsByEventTypeEventArea(this.eventService.activeEventType, this.container.eventArea, this.pagination).then((events:any) => {
  //     this.container.items.push(...events);
  //     if (paginator) paginator.complete();
  //   });
  // }
  loadNextPage(event: any) {
    this.pagination.page += 1;
    this.pagination.start += this.pagination.limit;

    this.getEventsByEventTypeEventArea(
      this.eventService.activeEventType,
      this.container.eventArea,
      this.pagination
    ).then((events: any[]) => {
      if (events.length < this.pagination.limit) {
        this.hasMoreItems = false;
      }

      this.container.items.push(...events);

      if (event?.target?.complete) {
        event.target.complete();
      }
    });
  }

  getEventsByEventTypeEventArea(eventType: string, eventArea: string, pagination: any) {
    return new Promise((resolve, reject) => {
      this.eventService.getEventSimple(eventType, eventArea, pagination).then(events => {
        let uniqueEvents = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
        uniqueEvents = uniqueEvents.slice(0, pagination.limit);
        resolve(uniqueEvents);
      });
    })
  }
}
